import { useDisclosure } from "@chakra-ui/hooks";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/modal";
import Card from "components/card/custom";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import { MdHighlightOff } from "react-icons/md";
import { MultiSelect } from "react-multi-select-component";
import { useOnClickOutsideSingel } from "utils/useOnClickOutside";
import DatePicker from "react-datepicker";


const FilterModal = ({
    clients,
    setPage,
    setFilter,
    filter,
    setLocalFilters,
    filterData,
    localFilters,
    setClearClick
} : {
    clients?: any;
    setPage?: any;
    filter?: any;
    setFilter?: (e: any) => void;
    setLocalFilters?: (e: any) => void;
    localFilters?: any;
    filterData?: () => void;
    setClearClick?: () => void;
}) => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
    const [isApplied,setIsApplied] = React.useState(false)
    const [isDirty, setIsDirty] = React.useState(false);
    
    const handleClose = () => {
        if (isDirty && !isApplied) {
            setFilter({
                client: [],
                dates: null,
            });
        }

        setIsDirty(false);
        setIsCloseModal(true);
        setTimeout(() => {
        setIsCloseModal(false);
        onClose();
        }, 300);
    };
    // const handleClose = () => {
    //     if(isApplied) {
    //         setFilter((prev : any) => ({
    //             client: (prev.client && prev.client.length) > 0 ? prev.client : [],
    //             dates: prev.dates || null,
    //         }));
            
    //     } else {
    //         setFilter({
    //             client: [],
    //             dates: null,
    //         });
    //     }
    //     setIsCloseModal(true);
    //     setTimeout(() => {
    //         setIsCloseModal(false);
    //         onClose();
    //     }, 300);
    // }
    
    return (
        <>
        <button
            className="my-1 rounded-full bg-indigo-600 px-3 py-2 text-white hover:bg-indigo-500 md:my-3"
            onClick={() => {
                onOpen();
                setIsApplied(false);
            }}
        >
            Apply Filter
        </button>
        {(filter?.client?.length > 0 ||
        filter?.dates) && (
            <button
            className="my-1 rounded-full bg-red-500 px-3 py-2 text-white hover:bg-red-400 md:my-3"
            onClick={() => {
                setFilter({
                    dates: null,
                });
                setIsApplied(false)
                setClearClick()
            }}
            >
            Clear Filter
            </button>
        )}
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${isOpen && !isCloseModal ? "card-enter" : "card-exit"}`}>
                <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">  
                    <MdHighlightOff
                    className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                    onClick={handleClose}
                    />
                Apply Filter
                </ModalHeader>
                <ModalBody className="p-2">
                    <div className="mx-[35px] ">
                        <div className="mb-3 block items-center gap-3">
                            <label className="block pb-[6px] text-sm font-bold text-gray-900 dark:text-white">
                                Clients :
                            </label>
                            <MultiSelect
                                options={clients?.[0]?.map((m: any) => {
                                return {
                                    label: m?.name,
                                    value: m?.client_id,
                                };
                                })}
                                value={clients?.[0]
                                ?.map((m: any) => {
                                    return {
                                    label: m?.name,
                                    value: m?.client_id,
                                    };
                                })
                                .filter((f: any) => filter?.client?.includes(f?.value))}
                                onChange={(e: any) => {
                                    setIsDirty(true);
                                    setFilter((prev: any) => {
                                        return {
                                        ...prev,
                                        client: e.map((m: any) => m?.value),
                                        };
                                    });
                                    setLocalFilters((prev: any) => {
                                        return {
                                        ...prev,
                                        client: e.map((m: any) => m?.value),
                                        };
                                    });
                                }}
                                labelledBy={"Select"}
                                isCreatable={true}
                            />
                            </div>
                            <div className="mb-3 items-center gap-4">
                            <label className="block pb-[6px] text-sm font-bold text-gray-900 dark:text-white">
                                Date :
                            </label>
                            <DatePicker
                                className="w-full rounded border  p-3 outline-none"
                                placeholderText="Select Date Range"
                                startDate={
                                filter?.start_date ? new Date(filter?.start_date) : null
                                }
                                endDate={
                                filter?.end_date ? new Date(filter?.end_date) : null
                                }
                                selectsRange={true}
                                isClearable={true}
                                onChange={(dateRange) => {
                                    setIsDirty(true);
                                    const [a, b] = dateRange;
                                    setFilter((prev: any) => {
                                        return {
                                        ...prev,
                                        start_date: a,
                                        end_date: b,
                                        };
                                    });
                                    if (a != null && b != null) {
                                        setFilter((prev: any) => {
                                        return {
                                            ...prev,
                                            dates: [a, b],
                                        };
                                        });
                                    } else {
                                        setFilter((prev: any) => {
                                        return {
                                            ...prev,
                                            dates: null,
                                        };
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="mt-[10px]">
                    <div className="mt-5 flex gap-2 px-[30px] pb-[10px]">
                        <button
                            onClick={handleClose}
                            className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                            // className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                        >
                            Close
                        </button>
                        <button
                            onClick={() => {
                            setPage(1);
                            filterData();
                            setIsApplied(true);
                            setIsDirty(false);
                            onClose();
                            }}
                            className="linear rounded-xl bg-indigo-600 px-5 py-2 text-base font-medium text-white outline-none transition duration-200 hover:bg-indigo-600 active:bg-indigo-600 dark:bg-indigo-400/10 dark:text-white dark:hover:bg-indigo-300/10 dark:active:bg-indigo-200/10"
                        >
                            Apply  
                        </button>
                        </div>
                    </ModalFooter>
            </Card>
        </Modal>
        </>
    )
}

export default FilterModal;